import type { useLoanRequestStatusesWithMailTrigger } from '~/features/leadDetails/hooks/useLoanRequestStatusesWithMailTrigger';

// two-column dialog with mail preview only for statuses that have at least one division mail template
export const hasAnyMailTrigger = (
    statusesWithMailTrigger: ReturnType<typeof useLoanRequestStatusesWithMailTrigger>['data'],
    status: string | undefined,
) => {
    const triggers = Object.entries(statusesWithMailTrigger ?? {}).find(([key]) => key === status)?.[1];
    return Object.values(triggers ?? {}).some(Boolean);
};
